import { render, staticRenderFns } from "./RouterFile.vue?vue&type=template&id=e0b62774&"
import script from "./RouterFile.vue?vue&type=script&lang=js&"
export * from "./RouterFile.vue?vue&type=script&lang=js&"
import style0 from "./RouterFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports